<template>
    <section>
        <o-tabs expanded>
            <o-tab-item label="Pictures" icon="images" />
            <o-tab-item label="Music" icon="music" />
            <o-tab-item label="Words" />
            <o-tab-item label="Videos" icon="video" />
        </o-tabs>
    </section>
</template>
